import { z } from 'zod'

export const refreshTokenRecordSchema = z
  .object({
    uid: z.string(),
    /** Associate a refresh token with a team */
    teamUid: z.string().nullable(),
    /** Token expiry in seconds */
    expiry: z.number().int(),
    /** Tracks if a token has been used. No refresh token should be reused */
    used: z.boolean(),
    /** family id is used to remove all tokens for a family in the event of a reuse */
    familyId: z.string(),
    /** Unique lookup for the user */
    userIndex: z.string(),
  })
  .meta({ id: 'refresh-token-record' })
export type RefreshTokenRecord = z.infer<typeof refreshTokenRecordSchema>
